import { makeStyles, Text, Title2, Title3 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    section: {
        padding: "4rem 0",
        backgroundColor: dolphinTokens.colorSkyLavender20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    textCenter: {
        textAlign: "center",
        width: "100%"
    },
    sectionTitle: {
        fontSize: "2.5rem",
        fontWeight: 600,
        marginBottom: "2rem",
        color: "#333",
        lineHeight: 1,
        padding: "0 1rem",
        textAlign: "center",

        "@media (max-width: 767px)": {
            marginBottom: "1rem"
        },

        "& .highlight": {
            color: dolphinTokens.colorLightBlue
        }
    },
    ceoContent: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        width: "100%",
        "@media (max-width: 767px)": {
            flexDirection: "column",
            alignItems: "center"
        }
    },
    imgColumn: {
        flex: "1 1 33%",
        paddingTop: "6rem",
        textAlign: "center",

        "@media (max-width: 767px)": {
            flex: "1 1 100%",
            paddingTop: "3rem",
            textAlign: "center"
        },
        
        "& img": {
            width: "100%",
            maxWidth: "300px",
            height: "auto",
            borderRadius: "10px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
            transition: "box-shadow 0.3s ease",

            "&:hover": {
                boxShadow: "0 15px 30px rgba(0,0,0,0.4)"
            }
        }
    },
    textColumn: {
        flex: "2 1 66%",
        marginLeft: "2rem",
        paddingRight: "3rem",
        
        "@media (max-width: 767px)": {
            flex: "1 1 100%",
            marginLeft: "0",
            marginTop: "2rem",
            paddingLeft: "1rem",
            paddingRight: "1rem"
        },

        "& p": {
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "#495057",
            marginBottom: "1.5rem"
        }
    },
    header: {
        fontSize: "1.5rem",
        fontWeight: 600,
        color: dolphinTokens.colorLightBlue,
        marginTop: "1.5rem",
        marginBottom: "1rem"
    }
});

export default function CEO() {
    const { t } = useTranslation("ourstory");
    const styles = useStyles();

    return (
        <section className={styles.section}>
            <div className={styles.textCenter}>
                <Title2 block as="h2" className={styles.sectionTitle}>
                    <span dangerouslySetInnerHTML={{ __html: t("ceo.title") }} />
                </Title2>
            </div>
            <div className={styles.ceoContent}>
                <div className={styles.imgColumn}>
                    <img src="/img/story/andy.jpg" alt="Andy Taylor" />
                </div>
                <div className={styles.textColumn}>
                    <div>
                        <Title3 block className={styles.header}>{t("ceo.text.behindTheWall.title")}</Title3>
                        <Text block as="p">{t("ceo.text.behindTheWall.content")}</Text>
                    </div>
                    <div>
                        <Title3 block className={styles.header}>{t("ceo.text.pushingBoundaries.title")}</Title3>
                        <Text block as="p">{t("ceo.text.pushingBoundaries.content")}</Text>
                    </div>
                    <div>
                        <Title3 block className={styles.header}>{t("ceo.text.pathToConsulting.title")}</Title3>
                        <Text block as="p">{t("ceo.text.pathToConsulting.content")}</Text>
                    </div>
                </div>
            </div>
        </section>
    );
}